import React from 'react'
import Info from '../Info'

interface LocalFilterInfoProps {
  title: string
}

const LocalFilterInfo: React.FC<LocalFilterInfoProps> = ({ title }) => {
  return (
    <>
      <Info
        text={
          'This filter will only search on the current result page you are viewing'
        }
      />
      <label style={{ marginLeft: 6 }}>{title}</label>
    </>
  )
}

export default LocalFilterInfo
